import { Center, HStack, Text, VStack } from '@chakra-ui/react';
import { APP_NAME } from '@/constants/stringVars';
import { MYOLogo } from '@/components/icons/domains/MYOLogo';
import { primary } from '@/theme/colors/palettes';

const PeerPulse = () => {
  return (
    <Center w={'100%'} pt={10} pb={16}>
      <HStack gap={3}>
        <MYOLogo color={primary[500]} size={40} />
        <VStack alignItems={'start'} gap={0}>
          <HStack gap={0} width={'100%'}>
            <Text fontSize={'16px'} lineHeight={'16px'} fontWeight={900}>
              Peer
            </Text>
            <Text fontSize={'16px'} lineHeight={'16px'} fontWeight={700}>
              Pulse
            </Text>
            <Text pb={1.5} fontSize={'10px'} lineHeight={'16px'} fontWeight={700}>
              TM
            </Text>
          </HStack>
          <Text
            fontSize={'12px'}
            lineHeight={'14px'}
            fontWeight={700}
            color={'text.mediumGray'}
            textAlign={'start'}
            mb={1}
          >
            by {APP_NAME}
          </Text>
        </VStack>
      </HStack>
    </Center>
  );
};

export default PeerPulse;
